module.exports = __webpack_public_path__ + "images/marketing/pipelinedeals-vs-nimble.pdf";